import { useState, useEffect } from "react";
import Button from "../../../toolkit/ButtonV1";
import Divider from "@mui/material/Divider";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { Card, Grid, Box } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "../../../components/FormControl";
import Select from "@mui/material/Select";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import CheckListGridItem from "./CheckListGridItem";
import EmptyComponent from "../../../utils/EmptyComponent";
import CollectionsTemplate from "../../../components/CollectionsTemplate";
import { Link } from "react-router-dom";
import PlusIcon from "../../../icons/PlusIcon";
import ChecklistSectionList from "../../../components/checklist/ChecklistSectionList";
import { Draggable } from "react-beautiful-dnd";
import DragableList from "../../../components/CollectionsTemplate/re-arrange/RearrangeSectionList";

export default function CheckLists() {
  const params = new URLSearchParams(window.location.search);
  const templateId = params.get("t");

  const [collection, setCollection] = useState([]);
  const [temporarycollection, setTemporaryCollection] = useState([]);
  const [allowReorder, setAllowReorder] = useState(false);

  const SaveReorder = () => {
    axios
      .post(BaseURL.templateTool.ReorderCheckListSections, temporarycollection.map((item, index) => ({
        ...item,
        checklistSectionId: item.id
      })))
      .then((response) => {
        setAllowReorder(false);
      });
  };
  const cancelReoder = () => {
    setAllowReorder(false);
    setTemporaryCollection([]);
  };

   
  const reorderSections = (data) => {
    setTemporaryCollection(data?.map((item, index) => ({
      ...item,
      displayOrder: index + 1
    })));
    setAllowReorder(true);
  };

  const onDataReorder = (data) => {
    setTemporaryCollection(data);

  };
  function checklistDataAdaptor(data) {
    return {
      headers: [
        { id: "checklistName", text: "", width: "80%" },
        { id: "Action", text: "", width: "10%" },
        { id: "icons", text: "", width: "5%" },
        { id: "visibilityIcon", text: "", width: "5%" },
      ],
      isEditable: {
        callback: (item) => {},
        isVisible: true,
      },
      isDeletable: {
        callback: (item) => {},
        isVisible: false,
      },
      isVisibleOn: {
        callback: (item) => {},
        isVisible: true,
      },
      rows: data?.map((d, i) =>
        Object.assign({}, d, {
          key: d.checklistSectionId,
          templateId: templateId,
        })
      ),
    };
  }
  return (
    <>
      <ToastContainer />
      <div
        className="row bg"
        style={{
          minwidth: "100%",
          backgroundColor: "#F9FAFB",
          marginLeft: "auto",
        }}
      >
        <div className="col-sm-2 md-2 xl-2 block ">
          <Link
            to={"/CreateCustomTemplate"}
            style={{
              textTransform: "capitalize",
              textDecoration: "none",
              color: "rgb(97, 169, 251)",
            }}
          >
            {"<-- Back to Templates"}
          </Link>
        </div>
        <div className="col-sm-9 md-9 xl-9 pt-4">
          {allowReorder ? (
            <>
              <Grid
                container
                wrap="nowrap"
                sx={{
                  flexDirection: {
                    xs: "column",
                    md: "row",
                  },
                }}
                spacing={1}
                justify="flex-start"
              >
                <Grid item sx={{ margin: "auto" }}>
                  <Grid
                    container
                    className="text-align-center"
                    wrap="nowrap"
                    sx={{
                      flexDirection: {
                        xs: "column",
                        md: "row",
                        overflow: "auto",
                      },
                    }}
                    spacing={1}
                  >
                    <Grid item>
                      <Button
                        sx={{ minWidth: "130px" }}
                        role="secondary"
                        size="large"
                        label="Cancel"
                        onClick={cancelReoder}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        sx={{ minWidth: "130px" }}
                        role="secondary"
                        size="large"
                        label="Done"
                        onClick={SaveReorder}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              
                <DragableList rows={temporarycollection} onDataReorder={onDataReorder}/>
             
            </>
          ) : (
            <ChecklistSectionList
              templateId={templateId}
              reorderSections={reorderSections}
            />
          )}
        
        </div>
      </div>
    </>
  );
}
